import React from "react";
import {
  YouTubeEmbed,
  TikTokEmbed,
  InstagramEmbed,
  FacebookEmbed,
} from "react-social-media-embed";
const YOUTUBE_DEFAULT_HEIGHT = 390;

export default function Embed({ type, url }) {
  const [embedHeight, setEmbedHeight] = React.useState(YOUTUBE_DEFAULT_HEIGHT);
  if (type === "youtube") {
    return (
      <YouTubeEmbed
        url={url}
        height={embedHeight}
        youTubeProps={{
          onReady: async (r) =>
            (await r.target.getIframe()).addEventListener("load", () =>
              setEmbedHeight((height) => height + 1)
            ),
        }}
      />
    );
  }

  if (type === "facebook") {
    return <FacebookEmbed url={url} width={325} />;
  }

  if (type === "instagram") {
    return <InstagramEmbed url={url} width={325} />;
  }

  if (type === "tiktok") {
    return <TikTokEmbed url={url} width={325} />;
  }

  return null;
}
